// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"CN-z","categoryName":"DN-z","categoryNameSearchHeader":"EN-z","categoryContent":"FN-z","bottomAligned":"GN-z","image":"HN-z","imageNoBackground":"IN-z"};